import { Box, Divider, Grid, Skeleton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ClientModelFormSkeleton = () => {
  const { t } = useTranslation();

  return (
    <Box className="p-8">
      <Grid container spacing={2} justifyContent="center">
        <Grid
          size={{ xs: 12, sm: 12, md: 12 }}
          sx={{ justifyContent: "center" }}
        >
          <Typography gutterBottom variant="body2" sx={{ fontWeight: "bold" }}>
            {t("newClient.general_information")}
          </Typography>
          <Divider />
        </Grid>
        <Grid
          size={{ xs: 12, sm: 12, md: 12 }}
          sx={{ justifyContent: "center", mt: 1 }}
        >
          <Skeleton variant="rectangular" height={56} />
        </Grid>
        <Grid
          size={{ xs: 12, sm: 12, md: 12 }}
          sx={{ justifyContent: "center", marginTop: 4 }}
        >
          <Typography gutterBottom variant="body2" sx={{ fontWeight: "bold" }}>
            {t("newClient.mmm_model_information")}
          </Typography>
          <Divider />
        </Grid>
        <Grid size={{ xs: 12, sm: 4, md: 4 }} sx={{ justifyContent: "center" }}>
          <Box className="flex flex-col items-center mt-4">
            <Skeleton variant="text" width={120} height={24} className="mb-2" />
            <Skeleton variant="circular" width={56} height={56} />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 4, md: 4 }} sx={{ justifyContent: "center" }}>
          <Box className="flex flex-col items-center mt-4">
            <Skeleton variant="text" width={120} height={24} className="mb-2" />
            <Skeleton variant="circular" width={56} height={56} />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, sm: 4, md: 4 }} sx={{ justifyContent: "center" }}>
          <Box className="flex flex-col items-center mt-4">
            <Skeleton variant="text" width={120} height={24} className="mb-2" />
            <Skeleton variant="circular" width={56} height={56} />
          </Box>
        </Grid>
      </Grid>
      <Box className="flex justify-end p-8 gap-4">
        <Skeleton variant="circular" width={40} height={40} />
        <Skeleton variant="circular" width={40} height={40} />
      </Box>
    </Box>
  );
};
